export class UserRoles {
  static admin = 'TNGH-ADMIN';
  static cvteAdmin = 'ADMINISTRATOR';
  static wntAdmin = 'ADMINISTRATOR';
  static wntSupervisor = 'TOEZICHTHOUDER';
  static wntInstitutionAdmin = 'WNT_REGISTER_BEHEERDER';
  static wntInstitution = 'WNT_INSTELLING';
  static cvteClusterManager = 'CLUSTER_MANAGER';
  static cvteReception = 'RECEPTION';
  static resellerAdmin = 'RESELLER-ADMIN';
  static resellerSupportUser = 'RESELLER-SUPPORT-USER';
  static cateringCompanyAdmin = 'CATERING-COMPANY-ADMIN';
  static cateringCompanyUser = 'CATERING-COMPANY-USER';
  static user = 'USER';
}
